module.exports = __webpack_public_path__ + "static/img/excep_binding_def.4094d766.png";